import React, { useState, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import trashIcon from '../assets/img/trashIconBlack.svg';
import pencillIcon from '../assets/img/pencilIconBlack.svg';
import AddDataModal from './modal/AddMyDataModal';
import RemoveMyDataModal from './modal/RemoveMyDataModal';
import { amendMarketingPreferences, removeMarketingPreferences } from './MarketingPageActions';
import carImage from '../assets/img/crimson-red-modern-sport-racing-car.png';

const Cards = [
  {
    title: 'Amend my data',
    content:
      'Click here to change your marketing preferences or to update your record (e.g. a name change).',
    icon: pencillIcon,
  },
  {
    title: 'Remove my data',
    content: 'This will cease all marketing communications, from all channels.',
    icon: trashIcon,
  },
];

function MarketingPage() {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  // Add a class to <body> when any modal is open, for z-index CSS control
  useLayoutEffect(() => {
    if (isAddModalOpen || isRemoveModalOpen) {
      document.body.classList.add('marketing-modal-active');
    } else {
      document.body.classList.remove('marketing-modal-active');
    }
    return () => {
      document.body.classList.remove('marketing-modal-active');
    };
  }, [isAddModalOpen, isRemoveModalOpen]);
  const dispatch = useDispatch();

  const toggleModal = () => setIsAddModalOpen(!isAddModalOpen);
  const toggleRemoveModal = () => setIsRemoveModalOpen(!isRemoveModalOpen);

  return (
    <div className="register-page-container" style={{ position: 'relative' }}>
      <div className="marketing-page__inner">
        <h3>Update Your Details & Marketing Preferences</h3>
        <div className="marketing-page__content">
          <h4>Keeping In Touch</h4>
          <div className="marketing-page__cards mt-3">
            {Cards.map((card, index) => {
              const handleClick =
                card.title === 'Amend my data' ? toggleModal : toggleRemoveModal;
              return (
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${card.title}-${index}`}
                  className="marketing-page__card"
                  onClick={handleClick}
                >
                  <div className="marketing-page__card-header">
                    <img
                      src={card.icon}
                      alt={card.title}
                      className="marketing-page__card-icon"
                    />
                    <h5>{card.title}</h5>
                  </div>
                  <p className="marketing-page__card-content">{card.content}</p>
                </div>
              );
            })}
          </div>
          <p className="marketing-page__note mt-5">
            In accordance with ICO guidelines, our policy is that with regards to instructions
            to desist in marketing that electronic communications stop within a maximum of 28
            days of receiving the notice, and postal communications stop within a maximum of
            two months.
          </p>
        </div>
      </div>
      <img
        src={carImage}
        alt="Car"
        className="marketing-page__car-image"
        style={{
          position: 'absolute',
          right: -50,
          bottom: 0,
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
      <AddDataModal
        isOpen={isAddModalOpen}
        toggle={toggleModal}
        onSave={async (data) => {
          await dispatch(amendMarketingPreferences(data));
        }}
      />
      <RemoveMyDataModal
        isOpen={isRemoveModalOpen}
        toggle={toggleRemoveModal}
        onSave={async (data) => {
          await dispatch(removeMarketingPreferences(data));
        }}
      />
    </div>
  );
}

export default MarketingPage;
